// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1D-HA","file":"styles_file__1abT0"};